import { EnvCommon } from '@bcflit-env/types';
import { initI18n } from '../../init-i18n';

async function loadLocalize(lang: string): Promise<Record<string, any>> {
  if (lang === 'pl') {
    // eslint-disable-next-line @typescript-eslint/typedef
    return await import('@bcflit-i18n/tikal-casino/generated/locales/pl').then((mod) => mod.templates);
  }
  if (lang === 'de') {
    // eslint-disable-next-line @typescript-eslint/typedef
    return await import('@bcflit-i18n/tikal-casino/generated/locales/de').then((mod) => mod.templates);
  }
  if (lang === 'fr') {
    // eslint-disable-next-line @typescript-eslint/typedef
    return await import('@bcflit-i18n/tikal-casino/generated/locales/fr').then((mod) => mod.templates);
  }
  if (lang === 'tr') {
    // eslint-disable-next-line @typescript-eslint/typedef
    return await import('@bcflit-i18n/tikal-casino/generated/locales/tr').then((mod) => mod.templates);
  }
  if (lang === 'en') {
    // eslint-disable-next-line @typescript-eslint/typedef
    return await import('@bcflit-i18n/tikal-casino/generated/locales/en_US').then((mod) => mod.templates);
  }
  return {};
}

function mapLangToLocalizeLocale(lang: string): string {
  if (lang === 'en') {
    return 'en_US';
  }
  return lang;
}

export function bootstrapAppI18n(env: EnvCommon): Promise<void> {
  return initI18n(env, (lang: string) => loadLocalize(lang), mapLangToLocalizeLocale);
}
